import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Pagination,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box
} from "@mui/material";
import { useDispatch } from "react-redux";
import { getNewsletterSubscribers, unsubscribeNewsletterSubscriber } from "store/actions";
import EmailIcon from "@mui/icons-material/Email";
import CancelIcon from "@mui/icons-material/Cancel";

const NewsletterSubscribers = () => {
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterSubscribed, setFilterSubscribed] = useState("");
  const dispatch = useDispatch();
  const [subscribers, setSubscribers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    fetchSubscribers();
  }, [dispatch, page, filterSubscribed]);

  useEffect(() => {
    let timerOut = setTimeout(async () => {
      fetchSubscribers();
    }, 800);
    return () => clearTimeout(timerOut);
  }, [searchTerm]);

  const fetchSubscribers = () => {
    dispatch(
      getNewsletterSubscribers(
        page + 1,
        10,
        searchTerm,
        filterSubscribed,
        (result) => {
          setSubscribers(result.data || []);
          setTotalPages(result.totalPages || 0);
        }
      )
    );
  };

  const handleChangePage = (event, value) => {
    setPage(value - 1);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };

  const handleFilterChange = (event) => {
    setFilterSubscribed(event.target.value);
    setPage(0);
  };

  const handleUnsubscribe = (id) => {
    dispatch(
      unsubscribeNewsletterSubscriber(id, (result) => {
        if (result?.code === 200) {
          fetchSubscribers();
        }
      })
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <Typography variant="h5">Newsletter Subscribers</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Search by email"
                variant="outlined"
                fullWidth
                value={searchTerm}
                size="small"
                onChange={handleSearchChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Subscription Status</InputLabel>
                <Select
                  value={filterSubscribed}
                  label="Subscription Status"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="true">Subscribed</MenuItem>
                  <MenuItem value="false">Unsubscribed</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <TableContainer component={Paper} style={{ marginTop: "17px" }}>
                <Table aria-label="newsletter subscribers table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Box display="flex" alignItems="center" gap={1}>
                          <EmailIcon fontSize="small" />
                          Email
                        </Box>
                      </TableCell>
                      <TableCell>Source</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Subscribed At</TableCell>
                      <TableCell>Unsubscribed At</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {subscribers.length > 0 ? (
                      subscribers.map((subscriber) => (
                        <TableRow
                          style={{
                            borderBottom: "1px solid #e0e0e0",
                          }}
                          key={subscriber._id}
                        >
                          <TableCell>{subscriber.email}</TableCell>
                          <TableCell>{subscriber.source || "landing_page"}</TableCell>
                          <TableCell>
                            <Chip
                              label={subscriber.isSubscribed ? "Subscribed" : "Unsubscribed"}
                              color={subscriber.isSubscribed ? "success" : "default"}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>{formatDate(subscriber.subscribedAt)}</TableCell>
                          <TableCell>{formatDate(subscriber.unsubscribedAt)}</TableCell>
                          <TableCell>
                            {subscriber.isSubscribed && (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={() => handleUnsubscribe(subscriber._id)}
                              >
                                Unsubscribe
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          align="center"
                          sx={{ borderBottom: "none" }}
                        >
                          No subscribers found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" mt={2} xs={12} sm={12} md={12}>
        <Pagination
          count={Math.ceil(totalPages)}
          color="secondary"
          size="small"
          page={page + 1}
          onChange={handleChangePage}
        />
      </Grid>
    </>
  );
};

export default NewsletterSubscribers;
